// 使用する場合はiframeクエリパラメータに"enablejsapi=1"を追加する
class YouTubeController {
  constructor(iframe) {
    this.targetWindow = iframe.contentWindow;
  }
  #control (action, args = null) {
    this.targetWindow.postMessage(`{"event":"command","func":"${action}","args":${args}}`, '*');
  };
  play() {
    this.#control('playVideo');
  }
  pause() {
    this.#control('pauseVideo');
  }
  stop() {
    this.#control('stopVideo');
  }
  clear() {
    this.#control('clearVideo');
  }
  load(id) {
    console.log("c:"+id)
    this.#control('cueVideoById', `"${id}"`);
  }
}
export default YouTubeController;